/* NOVA SELECT LAB — store.js
   Real Shopify Ajax cart (cart.js / add.js / change.js).
   Product page follows the site-reference design template interactions:
   plan-option cards, quantity control, add-to-bag with selected price,
   gallery #gallery-image / #gallery-video / [data-gallery] thumbs, sticky bar.
*/
(function () {
  'use strict';

  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  const I18N = window.NOVA || { t: {}, dialogs: {} };

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(I18N.locale || undefined, {
        style: 'currency', currency: I18N.currency || 'USD',
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format((cents || 0) / 100);
    } catch (e) { return '$' + ((cents || 0) / 100).toFixed(2); }
  };
  const t = (key) => (I18N.t && I18N.t[key]) ? I18N.t[key] : key;

  const rootUrl = () =>
    (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  async function fetchJson(url, options) {
    const res = await fetch(url, options);
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const msg = (data && (data.description || data.message)) || (res.statusText || ('HTTP ' + res.status));
      throw new Error(msg);
    }
    return data;
  }

  /* ---------- Cart API ---------- */
  const getCart = () => fetchJson(rootUrl() + 'cart.js');
  const addToCart = (variantId, quantity) =>
    fetchJson(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    });
  const changeLine = (key, quantity) =>
    fetchJson(rootUrl() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });

  /* ---------- DOM refs ---------- */
  const cartDrawer = $('#cart-drawer');
  const cartBackdrop = $('.cart-backdrop');
  const cartItemsEl = $('#cart-items');
  const cartTotalEl = $('[data-cart-total]');
  const cartCountEl = $('[data-cart-count]');
  const cartToggle = $('.cart-toggle');
  const closeCartBtn = $('.close-cart');
  const dialog = $('#info-dialog');
  const dialogClose = $('.dialog-close');
  let returnFocus = null;

  function lock() { document.body.classList.toggle('is-locked', !cartDrawer.hidden || dialog.open); }

  /* ---------- Render cart ---------- */
  function renderCart(cart) {
    const count = cart.item_count || 0;
    if (cartCountEl) cartCountEl.textContent = String(count);
    if (cartToggle) cartToggle.setAttribute('aria-label', t('cart.title') + ' (' + count + ')');

    if (!cart.items || !cart.items.length) {
      if (cartItemsEl) cartItemsEl.innerHTML = '<div class="empty-cart"><p>' + t('cart.empty') + '</p></div>';
      if (cartTotalEl) cartTotalEl.textContent = money(0);
      return;
    }
    if (cartItemsEl) {
      cartItemsEl.innerHTML = cart.items.map((item) => {
        const img = (item.featured_image && item.featured_image.url)
          ? '<img src="' + item.featured_image.url + '" width="100" height="124" alt="' + String(item.title || '').replace(/"/g, '&quot;') + '" loading="lazy">'
          : '';
        const opts = (item.options && item.options.length) ? item.options.join(' · ').replace(/"/g, '&quot;') : '';
        const price = money(item.final_line_price != null ? item.final_line_price : (item.quantity ? item.price * item.quantity : 0));
        return '<article class="cart-item" data-line-key="' + item.key + '">' + img +
          '<div><h3>' + String(item.title || '').replace(/"/g, '&quot;') + '</h3>' +
          '<p>' + opts + '</p>' +
          '<strong class="cart-item-price">' + price + '</strong>' +
          '<div class="cart-item-controls"><div class="quantity-control">' +
          '<button type="button" data-cart="minus" data-key="' + item.key + '" aria-label="−">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button type="button" data-cart="plus" data-key="' + item.key + '" aria-label="+">+</button>' +
          '</div><button type="button" class="remove-item" data-cart="remove" data-key="' + item.key + '">' + t('cart.remove') + '</button></div></div></article>';
      }).join('');
    }
    if (cartTotalEl) cartTotalEl.textContent = money(cart.total_price || 0);
  }

  async function refreshCart() {
    try { const cart = await getCart(); renderCart(cart); } catch (e) { console.error('Could not load cart', e); }
  }

  /* ---------- Cart UI ---------- */
  async function openCart() {
    returnFocus = document.activeElement;
    if (dialog && dialog.open) dialog.close();
    if (cartDrawer) cartDrawer.hidden = false;
    if (cartBackdrop) cartBackdrop.hidden = false;
    lock();
    await refreshCart();
    if (closeCartBtn) closeCartBtn.focus();
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.hidden = true;
    if (cartBackdrop) cartBackdrop.hidden = true;
    lock();
    if (returnFocus && returnFocus.isConnected) returnFocus.focus();
  }

  function bindCartEvents() {
    if (cartToggle) cartToggle.addEventListener('click', openCart);
    if (closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
    if (cartBackdrop) cartBackdrop.addEventListener('click', closeCart);
    const checkoutEl = $('[data-checkout]');
    if (checkoutEl) checkoutEl.setAttribute('href', rootUrl() + 'checkout');

    if (cartItemsEl) cartItemsEl.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-cart]');
      if (!b) return;
      const key = b.dataset.key;
      const action = b.dataset.cart;
      const itemEl = b.closest('.cart-item');
      const qtyEl = itemEl && itemEl.querySelector('span');
      const curQty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      let nextQty = curQty;
      if (action === 'minus') nextQty = curQty - 1;
      else if (action === 'plus') nextQty = curQty + 1;
      else if (action === 'remove') nextQty = 0;
      if (nextQty < 0) nextQty = 0;
      try {
        await changeLine(key, nextQty);
        await refreshCart();
        const f = itemEl ? $(('[data-cart="' + action + '"][data-key="' + key + '"]'), itemEl) : null;
        (f || closeCartBtn || cartToggle) && (f || closeCartBtn || cartToggle).focus();
      } catch (err) { console.error('Could not update item', err); }
    });
  }

  /* ---------- Product page: plan + quantity + add to bag ---------- */
  function bindProduct() {
    const root = $('.product-purchase');
    if (!root) return;

    const plans = $$('.plan-option', root);
    const qtyInput = $('#purchase-quantity');
    const selectedPrice = $('#selected-price');
    const stickyPrice = $('#sticky-price');
    const addBtn = $('#add-to-bag');

    let plan = null;   // selected variant (plan-option element)
    const quantity = () => {
      const n = qtyInput ? Number(qtyInput.value) : 1;
      return Math.max(1, Math.min(99, Number.isFinite(n) ? Math.trunc(n) : 1));
    };

    const updateTotal = () => {
      const price = plan ? Number(plan.dataset.price || 0) : 0;
      const total = money(price * quantity());
      if (selectedPrice) selectedPrice.textContent = total;
      if (stickyPrice) stickyPrice.textContent = total;
    };

    const choose = (target) => {
      if (plan === target) return;
      plan = target;
      plans.forEach((b) => {
        const active = b === target;
        b.classList.toggle('is-selected', active);
        b.setAttribute('aria-checked', String(active));
        b.tabIndex = active ? 0 : -1;
      });
      updateTotal();
    };

    plans.forEach((b, i) => {
      b.addEventListener('click', () => choose(b));
      b.addEventListener('keydown', (e) => {
        if (['ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(e.key)) {
          e.preventDefault();
          const target = e.key === 'Home' ? plans[0] : e.key === 'End' ? plans[plans.length - 1] : plans[(i + (['ArrowLeft', 'ArrowUp'].includes(e.key) ? -1 : 1) + plans.length) % plans.length];
          choose(target); target.focus();
        }
      });
    });
    if (plans.length) plan = plans[0]; // default Solo

    $$('[data-quantity]', root).forEach((b) => {
      b.addEventListener('click', () => { if (qtyInput) { qtyInput.value = Math.max(1, Math.min(99, quantity() + Number(b.dataset.quantity))); updateTotal(); } });
    });
    if (qtyInput) {
      qtyInput.addEventListener('input', updateTotal);
      qtyInput.addEventListener('change', () => { qtyInput.value = quantity(); updateTotal(); });
    }

    if (addBtn) addBtn.addEventListener('click', async () => {
      if (!plan) return;
      const qty = quantity();
      // brief busy state
      addBtn.classList.add('is-busy');
      const originalSpan = $('span:first-child', addBtn);
      if (originalSpan) originalSpan.textContent = t('cart.adding') || 'Adding…';
      try {
        await addToCart(parseInt(plan.dataset.variantId, 10), qty);
        await refreshCart();
        await openCart();
      } catch (err) {
        console.error('Could not add to cart', err);
        if (originalSpan) originalSpan.textContent = t('cart.error') || 'Could not add to bag';
      }
      addBtn.classList.remove('is-busy');
      if (originalSpan) originalSpan.textContent = t('products.add_to_cart');
    });

    // sticky bar visibility
    const sticky = $('.sticky-purchase');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      const stickyToggle = ([entry]) => { sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; };
      new IntersectionObserver(stickyToggle, { threshold: 0 }).observe(addBtn);
    }

    updateTotal();
  }

  /* ---------- Gallery (design template: #gallery-image/#gallery-video/[data-gallery]) ---------- */
  function bindGallery() {
    const root = $('.product-purchase');
    if (!root) return;
    const stage = $('.gallery-stage', root);
    const imageEl = stage ? $('#gallery-image', stage) : null;
    const videoEl = stage ? $('#gallery-video', stage) : null;
    const captionEl = stage ? $('#gallery-caption', stage) : null;
    const thumbs = $$('[data-gallery]', root);
    const dataEl = $('#gallery-data');
    let items = [];
    try { items = dataEl ? JSON.parse(dataEl.textContent) : []; } catch (e) {}
    if (!items.length) {
      // fallback: one image
      items = [{ type: 'image', src: imageEl ? imageEl.src : '', alt: captionEl ? captionEl.textContent : '' }];
    }
    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

    function show(idx) {
      const it = items[idx];
      if (!it) return;
      thumbs.forEach((th, i) => th.setAttribute('aria-pressed', String(i === idx)));
      if (it.type === 'video') {
        if (imageEl) imageEl.hidden = true;
        if (videoEl) { if (videoEl.dataset.activeSrc !== it.src) { videoEl.querySelectorAll('source').forEach(n => n.remove()); videoEl.src = it.src; videoEl.dataset.activeSrc = it.src; if (it.poster) videoEl.poster = it.poster; videoEl.load(); } videoEl.hidden = false; if (videoEl.dataset.userPaused !== 'true' && !reducedMotion.matches) { const pr = videoEl.play(); if (pr && pr.catch) pr.catch(() => {}); } }
      } else {
        if (videoEl) { videoEl.pause(); videoEl.hidden = true; }
        if (imageEl) { imageEl.hidden = false; imageEl.src = it.src; imageEl.alt = it.alt || ''; }
      }
      if (captionEl) captionEl.textContent = it.alt || '';
      if (stage) stage.dataset.kind = String(idx);
    }

    thumbs.forEach((th, i) => {
      th.addEventListener('click', () => show(i));
      th.addEventListener('keydown', (e) => {
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) {
          e.preventDefault();
          const n = e.key === 'Home' ? 0 : e.key === 'End' ? thumbs.length - 1 : (i + (e.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length;
          show(n); thumbs[n].focus();
        }
      });
    });

    if (videoEl) {
      videoEl.muted = true; videoEl.defaultMuted = true; videoEl.loop = true;
      const toggle = stage && $('.motion-toggle', stage);
      const stateFn = () => {
        if (!toggle) return;
        toggle.textContent = videoEl.paused ? '▶' : '❚❚';
        toggle.setAttribute('aria-label', videoEl.paused ? (I18N.locale === 'fr' ? 'Lire la vidéo' : 'Play video') : (I18N.locale === 'fr' ? 'Mettre en pause' : 'Pause video'));
      };
      if (toggle) toggle.addEventListener('click', () => {
        if (videoEl.paused) { videoEl.dataset.userPaused = 'false'; videoEl.play().catch(() => {}); }
        else { videoEl.dataset.userPaused = 'true'; videoEl.pause(); }
      });
      videoEl.addEventListener('play', stateFn);
      videoEl.addEventListener('pause', stateFn);
      stateFn();
    }

    show(0);
  }

  /* ---------- Info dialogs ---------- */
  function bindDialogs() {
    $$('[data-dialog]').forEach((b) => b.addEventListener('click', () => {
      const key = b.dataset.dialog;
      const data = I18N.dialogs && I18N.dialogs[key];
      if (!data) return;
      returnFocus = b;
      if (!cartDrawer.hidden) closeCart();
      const content = $('#dialog-content');
      if (!content) return;
      content.replaceChildren();
      const eye = document.createElement('p'); eye.className = 'eyebrow'; eye.textContent = 'NOVA SELECT LAB';
      const h = document.createElement('h2'); h.textContent = data[0];
      const p = document.createElement('p'); p.textContent = data[1];
      const a = document.createElement('a'); a.href = 'mailto:service@novaselectlab.com'; a.textContent = 'service@novaselectlab.com';
      content.append(eye, h, p, a);
      dialog.showModal(); lock();
    }));
    if (dialogClose) dialogClose.addEventListener('click', () => { dialog.close(); lock(); });
    if (dialog) dialog.addEventListener('click', (e) => { if (e.target === dialog) { dialog.close(); lock(); } });
  }

  /* ---------- Mobile menu ---------- */
  function bindMenu() {
    const toggle = $('.menu-toggle');
    const menu = $('#mobile-menu');
    if (!toggle || !menu) return;
    const close = () => { menu.hidden = true; toggle.setAttribute('aria-expanded', 'false'); };
    toggle.addEventListener('click', () => {
      const open = menu.hidden;
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
    });
    $$('#mobile-menu a').forEach((a) => a.addEventListener('click', close));
    window.addEventListener('resize', () => { if (window.innerWidth > 800) close(); });
  }

  /* ---------- Keyboard ---------- */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (!cartDrawer.hidden) closeCart();
      else { const m = $('#mobile-menu'); if (m && !m.hidden) m.hidden = true; }
    }
    if (e.key === 'Tab' && !cartDrawer.hidden) {
      const buttons = $$('#cart-drawer button:not(:disabled), #cart-drawer a[href]').filter((b) => b.getClientRects().length);
      if (!buttons.length) return;
      if (e.shiftKey && document.activeElement === buttons[0]) { e.preventDefault(); buttons[buttons.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === buttons[buttons.length - 1]) { e.preventDefault(); buttons[0].focus(); }
    }
  });

  /* ---------- Init ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    bindCartEvents();
    bindProduct();
    bindGallery();
    bindDialogs();
    bindMenu();
    refreshCart();
  });
})();
